module.exports = __webpack_public_path__ + "img/spring.0d0eed9c.svg";